<!-- Assign Users -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="5" class="mb-2"></app-skelitions>
<div class="container" [hidden]="skelition">
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>

  <div
    class="row filter-bg-color d-flex align-items-center justify-content-center my-4 mx-1 flex-wrap"
  >
    <!-- <div class="col-3">
            <p-treeSelect appendTo="body" class="w-md-20rem w-100" containerStyleClass="w-100" [(ngModel)]="oufilter"
                (ngModelChange)="filterFunction(false)" [options]="treeData" placeholder='{{"Select the organizational unit" | translator}}'
                [filter]="true" [filterInputAutoFocus]="true">
                <ng-template let-node pTemplate="default">
                    <div class="d-flex">
                        <img *ngIf="checkisImg(node.data); else elseBlock" src="{{staticURL}}{{node.data}}"
                            class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                        <ng-template #elseBlock>
                            <i class="{{node.data}} p-2" style="font-size: 1rem;"></i>
                        </ng-template>
                        <b class="text-nowrap">{{ node.label }}</b>
                    </div>
                </ng-template>
            </p-treeSelect>
        </div> -->
    <div class="col-md-9 col-12">
      <input
        placeholder="{{ 'Research' | translator }}"
        [(ngModel)]="attributeFilterValue"
        (ngModelChange)="attrubiteFilter($event, false)"
        class="w-100 assign-input"
        type="text"
        pInputText
      />
    </div>
    <div class="col-md-3 col-12 d-flex align-items-center justify-content-start">
      <button (click)="refresh()" class="v4-btn-every py-2 my-2">
        <i class="pi pi-refresh v4-ml-2"></i>{{ "Reset" | translator }}
      </button>
    </div>
  </div>

  <p-table
    class="manage-tr"
    [value]="filteredData"
    [(selection)]="selectionData"
    (onHeaderCheckboxToggle)="updateSelection($event, false, false)"
    [totalRecords]="filteredData.length"
    (onRowSelect)="updateSelection($event, true, false)"
    dataKey="_id"
    [paginator]="true"
    [rows]="10"
    [selectionPageOnly]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th style="min-width: 200px">{{ "user name" | translator }}</th>
        <th style="min-width: 200px">{{ "E-mail" | translator }}</th>
        <th style="min-width: 200px">{{ "phone number" | translator }}</th>
        <!-- <th *ngIf="isTraining" style="min-width:200px">{{"Able to attend" | translator}}</th> -->
        <th style="min-width: 200px">{{ "City" | translator }}</th>
        <th style="min-width: 200px" *ngIf="requestedUser">
          {{ "Is Request" | translator }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        <td>
          <p-tableCheckbox [value]="product"></p-tableCheckbox>
        </td>
        <td>
          <strong style="line-height: 1rem">{{
            product?.name?.first +
              " " +
              product?.name?.middle +
              " " +
              product?.name?.last
          }}</strong>
        </td>
        <td>{{ product?.email }}</td>
        <td>{{ product?.phone }}</td>
        <!-- <td *ngIf="isTraining">{{product?.allowed ? 'Yes':'no'}}</td> -->
        <td>
          {{ product.location ? product?.location?.name : "Unspecified" }}
        </td>
        <td
          *ngIf="requestedUser"
          pTooltip="{{
            (requestedUser.includes(product._id)
              ? 'Request Recieved'
              : 'No Request'
            ) | translator
          }}"
        >
          <p
            class="{{
              requestedUser.includes(product._id)
                ? 'pi pi-check color-green'
                : 'pi pi-exclamation-triangle color-red'
            }}"
          ></p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="mt-3 mb-5" *ngIf="fromMS == false">
    <button class="v4-btn-every mx-1" (click)="exit(false)">
      <i class="pi pi-arrow-right v4-ml-2"></i>{{ "Back" | translator }}
    </button>
    <button class="v4-btn-every mx-1" (click)="exit(true)">
      <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
    </button>
  </div>

  <ng-container *ngIf="selectionData && selectionData.length > 0">
    <hr class="color-grey" />
    <h3 class="color-grey">
      {{ "Identified users" | translator }}
    </h3>
    <div
      class="row filter-bg-color d-flex align-items-center justify-content-center my-4 mx-1"
    >
      <!-- <div class="col-3">
                <p-treeSelect appendTo="body" class="w-md-20rem w-100" containerStyleClass="w-100"
                    [(ngModel)]="selectedOuFilter" (ngModelChange)="filterFunction(true)" [options]="treeData"
                    placeholder='{{"Classification of entity services" | translator}}' [filter]="true" [filterInputAutoFocus]="true">
                    <ng-template let-node pTemplate="default">
                        <div class="d-flex">
                            <img *ngIf="checkisImg(node.data); else elseBlock" src="{{staticURL}}{{node.data}}"
                                class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                            <ng-template #elseBlock>
                                <i class="{{node.data}} p-2" style="font-size: 1rem;"></i>
                            </ng-template>
                            <b class="text-nowrap">{{ node.label }}</b>
                        </div>
                    </ng-template>
                </p-treeSelect>
            </div> -->
      <div class="col-md-9 col-12">
        <input
          placeholder="{{ 'Research' | translator }}"
          [(ngModel)]="attributeFilterValueSelected"
          (ngModelChange)="attrubiteFilter($event, true)"
          class="w-100 assign-input"
          type="text"
          pInputText
        />
      </div>
      <div class="col-md-3 col-12 d-flex align-items-center justify-content-start">
        <button (click)="refresh()" class="v4-btn-every py-2 my-2">
          <i class="pi pi-refresh v4-ml-2"></i>{{ "Reset" | translator }}
        </button>
      </div>
    </div>
    <p-table
      class="manage-tr"
      [value]="filteredSelection"
      [(selection)]="selectionData"
      (onHeaderCheckboxToggle)="updateSelection($event, false, true)"
      (onRowUnselect)="updateSelection($event, true, true)"
      dataKey="_id"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="min-width: 200px">{{ "user name" | translator }}</th>
          <th style="min-width: 200px">{{ "E-mail" | translator }}</th>
          <th style="min-width: 200px">{{ "phone number" | translator }}</th>
          <th style="min-width: 200px">{{ "City" | translator }}</th>
          <th style="min-width: 200px" *ngIf="requestedUser">
            {{ "Is Request" | translator }}
          </th>

          <!-- <th>{{"user name" | translator}}</th>
                    <th>{{"E-mail" | translator}}</th>
                    <th>{{"phone number" | translator}}</th>
                    <th>{{"City" | translator}}</th> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <p-tableCheckbox [value]="product"></p-tableCheckbox>
          </td>
          <td>
            <strong style="line-height: 1rem">{{
              product?.name?.first +
                " " +
                product?.name?.middle +
                " " +
                product?.name?.last
            }}</strong>
          </td>
          <td>{{ product?.email }}</td>
          <td>{{ product?.phone }}</td>
          <td>
            {{ product.location ? product?.location?.name : "Unspecified" }}
          </td>
          <td
            *ngIf="requestedUser"
            pTooltip="{{
              (requestedUser.includes(product._id)
                ? 'Request Recieved'
                : 'No Request'
              ) | translator
            }}"
          >
            <p
              class="{{
                requestedUser.includes(product._id)
                  ? 'pi pi-check color-green'
                  : 'pi pi-exclamation-triangle color-red'
              }}"
            ></p>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <hr class="color-grey" />
  </ng-container>

  <div class="mt-3 mb-5" *ngIf="fromMS">
    <button class="v4-btn-every mx-1" (click)="exit(false)">
      <i class="pi pi-arrow-right v4-ml-2"></i>{{ "Back" | translator }}
    </button>
    <button class="v4-btn-every mx-1" (click)="exit(true)">
      <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
    </button>
  </div>

  <ng-container *ngIf="isTraining && busyUsers && busyUsers.length > 0">
    <hr class="color-grey" />
    <h1>
      {{
        "Users All ready assigned to some session at this moment" | translator
      }}
    </h1>

    <p-table
      class="manage-tr"
      [value]="busyUsers"
      dataKey="_id"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <!-- <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th> -->
          <th style="min-width: 200px">{{ "user name" | translator }}</th>
          <th style="min-width: 200px">{{ "E-mail" | translator }}</th>
          <th style="min-width: 200px">{{ "phone number" | translator }}</th>
          <th style="min-width: 200px">{{ "City" | translator }}</th>
          <th style="min-width: 200px">{{ "View Details" | translator }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <!-- <td>
                        <p-tableCheckbox [value]="product"></p-tableCheckbox>
                    </td> -->
          <td>
            <strong style="line-height: 1rem">{{
              product?.name?.first +
                " " +
                product?.name?.middle +
                " " +
                product?.name?.last
            }}</strong>
          </td>
          <td>{{ product?.email }}</td>
          <td>{{ product?.phone }}</td>
          <td>
            {{ product.location ? product?.location?.name : "Unspecified" }}
          </td>
          <td>
            <i
              (click)="viewDetails(product)"
              class="fa-solid fa-circle-exclamation v4-exclanation"
            ></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <hr class="color-grey" />
  </ng-container>
</div>

<p-dialog
  header="{{ 'Schedule' | translator }}"
  [(visible)]="showScheduleFlag"
  [style]="{ width: '70vw' }"
>
  <p-table
    class="manage-tr"
    [value]="userSchedule"
    dataKey="_id"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <!-- <th style="width: 4rem">
                 <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
             </th> -->
        <th>{{ "the name" | translator }}</th>
        <th>{{ "date" | translator }}</th>
        <th>{{ "Start time" | translator }}</th>
        <th>{{ "end time" | translator }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        <!-- <td>
                 <p-tableCheckbox [value]="product"></p-tableCheckbox>
             </td> -->
        <td>
          <strong style="line-height: 1rem">{{
            product?.trainingTitle
          }}</strong>
        </td>
        <td>
          {{ product?.date.day }}-{{ product?.date.month }}-{{
            product?.date.year
          }}
        </td>
        <td>{{ product?.t_start_time[0] }}:{{ product?.t_start_time[1] }}</td>
        <td>{{ product?.t_end_time[0] }}:{{ product?.t_end_time[1] }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<p-toast></p-toast>
